module.exports = __webpack_public_path__ + "static/media/32-6.d36d1e57.mp3";